'use client';

import React from 'react';
import { Container } from 'components/shared';
import { UHClueTitle } from './typography';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import useCluePricing from 'hooks/pricing/useCluePricing';
import styles from './WhatYouGet.module.css';

const WhatYouGet = () => {
  const { ringPriceDisplay, clueDiscountedDisplay, cluePriceDisplay } =
    useCluePricing();

  const items = [
    {
      title: 'Daily health insights, powered by Ultrahuman Ring',
      caption: 'Sleep, HRV, temperature, and movement tracking',
      iconUrl: '/web_v2/uh-x-clue/what-you-get/icon/ring-new.png',
    },
    {
      title: 'Clue Plus included',
      caption:
        'Advanced cycle tracking, deeper analysis, personalized predictions.',
      iconUrl: '/web_v2/uh-x-clue/what-you-get/icon/clue-new.png',
    },
    {
      title: 'Exclusive offer',
      caption: `Ring AIR at ${ringPriceDisplay}, bundled with Clue Plus for just ${clueDiscountedDisplay} (worth ${cluePriceDisplay})`,
      iconUrl: '/web_v2/uh-x-clue/what-you-get/icon/offer-new.png',
    },
  ];

  return (
    <section
      className={styles.section}
      role="region"
      aria-labelledby="whatyouget-heading"
      style={
        {
          ['--wyg-bg-mobile' as string]: `url(${getCompressedAssetUrl(
            '/web_v2/uh-x-clue/what-you-get/fade-bg-mob.png',
          )})`,
          ['--wyg-bg-desktop' as string]: `url(${getCompressedAssetUrl(
            '/web_v2/uh-x-clue/what-you-get/fade-bg.png',
          )})`,
        } as React.CSSProperties
      }
    >
      <Container>
        <div className={styles.inner}>
          <UHClueTitle
            className={styles.title}
            id="whatyouget-heading"
            $mobileColor="#fff"
            $desktopColor="#fff"
          >
            What you get
          </UHClueTitle>
          <div className={styles.grid}>
            {items.map((it) => (
              <div className={styles.item} key={it.title}>
                <div className={styles.iconWrapper}>
                  <img
                    className={styles.iconImage}
                    src={getCompressedAssetUrl(it.iconUrl)}
                    alt={it.title}
                  />
                </div>
                <div className={styles.textStack}>
                  <h3 className={styles.itemTitle}>{it.title}</h3>
                  <p className={styles.itemCaption}>{it.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default WhatYouGet;
